import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';
import { addNotification } from './notifications';
import {saveFile} from "../lib/content-lib";

export const GET_EMPLOYEES_REQUEST = 'GET_EMPLOYEES_REQUEST';
export const GET_EMPLOYEES_SUCCESS = 'GET_EMPLOYEES_SUCCESS';
export const GET_EMPLOYEES_ERROR = 'GET_EMPLOYEES_ERROR';

export const GET_EMPLOYEE_REQUEST = 'GET_EMPLOYEE_REQUEST';
export const GET_EMPLOYEE_SUCCESS = 'GET_EMPLOYEE_SUCCESS';
export const GET_EMPLOYEE_ERROR = 'GET_EMPLOYEE_ERROR';

export const CREATE_EMPLOYEE_REQUEST = 'CREATE_EMPLOYEE_REQUEST';
export const CREATE_EMPLOYEE_SUCCESS = 'CREATE_EMPLOYEE_SUCCESS';
export const CREATE_EMPLOYEE_ERROR = 'CREATE_EMPLOYEE_ERROR';

export const UPDATE_EMPLOYEE_REQUEST = 'UPDATE_EMPLOYEE_REQUEST';
export const UPDATE_EMPLOYEE_SUCCESS = 'UPDATE_EMPLOYEE_SUCCESS';
export const UPDATE_EMPLOYEE_ERROR = 'UPDATE_EMPLOYEE_ERROR';

export const CHANGE_STATUS_EMPLOYEE_REQUEST = 'CHANGE_STATUS_EMPLOYEE_REQUEST';
export const CHANGE_STATUS_EMPLOYEE_SUCCESS = 'CHANGE_STATUS_EMPLOYEE_SUCCESS';
export const CHANGE_STATUS_EMPLOYEE_ERROR = 'CHANGE_STATUS_EMPLOYEE_ERROR';

export const UPLOAD_EMPLOYEE_FILES_REQUEST = 'UPLOAD_EMPLOYEE_FILES_REQUEST';
export const UPLOAD_EMPLOYEE_FILES_PROGRESS = 'UPLOAD_EMPLOYEE_FILES_PROGRESS';
export const UPLOAD_EMPLOYEE_FILES_SUCCESS = 'UPLOAD_EMPLOYEE_FILES_SUCCESS';
export const UPLOAD_EMPLOYEE_FILES_ERROR = 'UPLOAD_EMPLOYEE_FILES_ERROR';

export const DELETE_EMPLOYEE_FILE_REQUEST = 'DELETE_EMPLOYEE_FILE_REQUEST';
export const DELETE_EMPLOYEE_FILE_SUCCESS = 'DELETE_EMPLOYEE_FILE_SUCCESS';
export const DELETE_EMPLOYEE_FILE_ERROR = 'DELETE_EMPLOYEE_FILE_ERROR';

export const DELETE_EMPLOYEE_REQUEST = 'DELETE_EMPLOYEE_REQUEST';
export const DELETE_EMPLOYEE_SUCCESS = 'DELETE_EMPLOYEE_SUCCESS';
export const DELETE_EMPLOYEE_ERROR = 'DELETE_EMPLOYEE_ERROR';

export const CLEAN_EMPLOYEES = 'CLEAN_EMPLOYEES';

// Get employees
export function getEmployees(query) {
    return async (dispatch) => {
        try {
            dispatch(getEmployeesRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/employees/query', query, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getEmployeesSuccess, getEmployeesError));
        } catch (err) {
            dispatch(utilsLib.response(err, getEmployeesError));
        }
    };
}

function getEmployeesRequest() {
    return {
        type: GET_EMPLOYEES_REQUEST,
        isFetching: true
    };
}

function getEmployeesSuccess (payload) {
    return {
        type: GET_EMPLOYEES_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}

function getEmployeesError(errorMessage) {
    return {
        type: GET_EMPLOYEES_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Get employee
export function getEmployee(employeeId) {

    return async (dispatch) => {
        try {
            dispatch(getEmployeeRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/employees/${employeeId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getEmployeeSuccess, getEmployeeError));
        } catch (err) {
            dispatch(utilsLib.response(err, getEmployeeError));
        }
    };
}

function getEmployeeRequest() {
    return {
        type: GET_EMPLOYEE_REQUEST,
        isFetching: true
    };
}

function getEmployeeSuccess (payload) {
    return {
        type: GET_EMPLOYEE_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}

function getEmployeeError(errorMessage) {
    return {
        type: GET_EMPLOYEE_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Create employee
export function createEmployee(employee, options) {
    return async (dispatch) => {
        try {
            dispatch(createEmployeeRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/employees', {employee, options}, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, createEmployeeSuccess, createEmployeeError));
        } catch (err) {
            dispatch(utilsLib.response(err, createEmployeeError));
        }
    };
}

function createEmployeeRequest() {
    return {
        type: CREATE_EMPLOYEE_REQUEST,
        isFetching: true
    };
}

function createEmployeeSuccess (payload) {
    return dispatch => {
        // Create notification for create employee success
        dispatch(addNotification({
            message: 'Empleado creado correctamente',
            color: 'green',
            icon: 'tick'
        }));

        dispatch({
            type: CREATE_EMPLOYEE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function createEmployeeError(errorMessage) {
    return dispatch => {
        // Create notification for create employee error
        dispatch(addNotification({
            message: 'Error al crear el empleado',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CREATE_EMPLOYEE_ERROR,
                isFetching: false,
                error: true,
                errorMessage
        });
    }
}

// Update employee
export function updateEmployee(employeeId, employee = {}) {
    return async (dispatch) => {
        try {
            dispatch(updateEmployeeRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/employees/${employeeId}`, employee, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateEmployeeSuccess, updateEmployeeError));
        } catch (err) {
            dispatch(utilsLib.response(err, updateEmployeeError));
        }
    };
}

function updateEmployeeRequest() {
    return {
        type: UPDATE_EMPLOYEE_REQUEST,
        isFetching: true
    };
}

function updateEmployeeSuccess (payload) {
    return dispatch => {
        // Create notification for update employee success
        dispatch(addNotification({
            message: 'Empleado actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPDATE_EMPLOYEE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function updateEmployeeError(errorMessage) {
    return dispatch => {
        // Create notification for update employee error
        dispatch(addNotification({
            message: 'Error al actualizar el empleado',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPDATE_EMPLOYEE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Change employee status
export function changeEmployeeStatus(employeeId, status, options = {}) {
    return async (dispatch) => {
        try {
            dispatch(changeEmployeeStatusRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/employees/${employeeId}/status`, { status, options }, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, changeEmployeeStatusSuccess, changeEmployeeStatusError));
        } catch (err) {
            dispatch(utilsLib.response(err, changeEmployeeStatusError));
        }
    };
}

function changeEmployeeStatusRequest() {
    return {
        type: CHANGE_STATUS_EMPLOYEE_REQUEST,
        isFetching: true
    };
}

function changeEmployeeStatusSuccess (payload) {
    return dispatch => {
        // Create notification for update status success
        dispatch(addNotification({
            message: 'Estado actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: CHANGE_STATUS_EMPLOYEE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function changeEmployeeStatusError(errorMessage) {
    return dispatch => {
        // Create notification for update status error
        dispatch(addNotification({
            message: 'Error al actualizar el estado',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CHANGE_STATUS_EMPLOYEE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Upload employee files
export function uploadEmployeeFiles(employeeId, files) {
    return async (dispatch) => {
        try {
            dispatch(uploadEmployeeFilesRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post(`/api/employees/${employeeId}/files`, files, {
                headers: { 'Authorization': 'Bearer ' + token },
                onUploadProgress: function (e) {
                    dispatch(uploadEmployeeFilesProgress(e.loaded / e.total))
                }
            });

            dispatch(utilsLib.response(res, uploadEmployeeFilesSuccess, uploadEmployeeFilesError));
        } catch (err) {
            dispatch(utilsLib.response(err, uploadEmployeeFilesError));
        }
    };
}
function uploadEmployeeFilesRequest() {
    return {
        type: UPLOAD_EMPLOYEE_FILES_REQUEST,
        isFetching: true
    };
}
function uploadEmployeeFilesProgress(percent) {
    return {
        type: UPLOAD_EMPLOYEE_FILES_PROGRESS,
        percent
    };
}
function uploadEmployeeFilesSuccess (payload) {
    return dispatch => {
        // Create notification for upload employee file success
        dispatch(addNotification({
            message: 'Ficheros subidos correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPLOAD_EMPLOYEE_FILES_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function uploadEmployeeFilesError(errorMessage) {
    return dispatch => {
        // Create notification for upload employee file error
        dispatch(addNotification({
            message: 'Error al subir los ficheros',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPLOAD_EMPLOYEE_FILES_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Download employee file
export function downloadEmployeeFile(employeeId, fileId) {
    return async (dispatch) => {
        try {
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/employees/${employeeId}/files/${fileId}`, {
                headers: { 'Authorization': 'Bearer ' + token },
                responseType: 'blob'
            });

            if( res.status === 200 ) {
                saveFile(res);
            }

        } catch (err) {
            dispatch(addNotification({
                message: 'Error al descargar el fichero',
                color: 'red',
                icon: 'warning-sign'
            }));
        }
    };
}

// Delete employee file
export function deleteEmployeeFile(employeeId, fileId) {
    return async (dispatch) => {
        try {
            dispatch(deleteEmployeeFileRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/employees/${employeeId}/files/${fileId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteEmployeeFileSuccess, deleteEmployeeFileError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteEmployeeFileError));
        }
    };
}
function deleteEmployeeFileRequest() {
    return {
        type: DELETE_EMPLOYEE_FILE_REQUEST,
        isFetching: true
    };
}
function deleteEmployeeFileSuccess (payload) {
    return dispatch => {
        // Create notification for delete file success
        dispatch(addNotification({
            message: 'Fichero eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_EMPLOYEE_FILE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deleteEmployeeFileError(errorMessage) {
    return dispatch => {
        // Create notification for delete file error
        dispatch(addNotification({
            message: 'Error al eliminar el fichero',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_EMPLOYEE_FILE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Delete employee
export function deleteEmployee(employeeId) {

    return async (dispatch) => {
        try {
            dispatch(deleteEmployeeRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/employees/${employeeId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteEmployeeSuccess, deleteEmployeeError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteEmployeeError));
        }
    };
}

function deleteEmployeeRequest() {
    return {
        type: DELETE_EMPLOYEE_REQUEST,
        isFetching: true
    };
}

function deleteEmployeeSuccess (payload) {
    return dispatch => {
        // Create notification for delete employee success
        dispatch(addNotification({
            message: 'Empleado eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_EMPLOYEE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function deleteEmployeeError(errorMessage) {
    return dispatch => {
        // Create notification for delete employee error
        dispatch(addNotification({
            message: 'Error al eliminar el empleado',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_EMPLOYEE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

export function cleanEmployees() {
    return {
        type: 'CLEAN_EMPLOYEES',
        isFetching: false,
        error: false,
        payload: []
    }
}



// WEBPACK FOOTER //
// ./src/actions/employees.js